import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '@screen';
import styled from 'styled-components';

const PlayerName = styled.span<React.CSSProperties>`
  bottom: ${Screen.widthRatio * 20}px;
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${Screen.widthRatio * 40}px;
  left: ${Screen.widthRatio * 20}px;
  position: absolute;
  z-index: 1;
`;

export default PlayerName;
